var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusclesFrontLayer1Drawio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "transparent",
      backgroundColor: "transparent",
      colorScheme: "light dark"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "655px",
    height: "893px",
    viewBox: "0 0 655 893",
    content: "<mxfile host=\"app.diagrams.net\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/18.6 Safari/605.1.15\" version=\"28.2.7\"> <diagram name=\"Page-1\" id=\"cyeuNWfrYWt35hCzf-kK\"> <mxGraphModel dx=\"1449\" dy=\"994\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"827\" pageHeight=\"1169\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <object label=\"\" class=\"pec major\" id=\"Tunu-VMid14RNrtfkO_W-2\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=15;class=pec major;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"298.9\" y=\"260.74\" width=\"122.39\" height=\"98.77\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"biceps\" id=\"Tunu-VMid14RNrtfkO_W-4\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=90;class=biceps;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"168\" y=\"195.24\" width=\"59.94\" height=\"100\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"abs\" id=\"Tunu-VMid14RNrtfkO_W-5\"> <mxCell style=\"rounded=1;whiteSpace=wrap;html=1;arcSize=40;class=abs;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"441.93435046521665\" y=\"402.0003903677105\" width=\"41\" height=\"196.1810566635748\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"abs\" id=\"Tunu-VMid14RNrtfkO_W-6\"> <mxCell style=\"rounded=1;whiteSpace=wrap;html=1;arcSize=40;class=abs;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"386.24164489860567\" y=\"402.0003903677105\" width=\"41\" height=\"196.1810566635748\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"side abs\" id=\"Tunu-VMid14RNrtfkO_W-7\"> <mxCell style=\"shape=xor;whiteSpace=wrap;html=1;rotation=-180;class=side abs;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"356.3492470231541\" y=\"421.618496034068\" width=\"24\" height=\"156.94484533085983\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"side abs\" id=\"Tunu-VMid14RNrtfkO_W-8\"> <mxCell style=\"shape=xor;whiteSpace=wrap;html=1;rotation=-180;direction=west;class=side abs;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"490.66883322021226\" y=\"421.618496034068\" width=\"24\" height=\"156.94484533085983\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"side\" id=\"Tunu-VMid14RNrtfkO_W-9\"> <mxCell style=\"shape=xor;whiteSpace=wrap;html=1;rotation=93;direction=west;class=side;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"523\" y=\"189\" width=\"44.26\" height=\"85.99\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"front quads\" id=\"Tunu-VMid14RNrtfkO_W-10\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=9;class=front quads;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"300\" y=\"610\" width=\"75.35\" height=\"180\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"calves\" id=\"Tunu-VMid14RNrtfkO_W-11\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-8;class=calves;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"449.62\" y=\"790\" width=\"50.17\" height=\"205.99\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"forearm\" id=\"Tunu-VMid14RNrtfkO_W-12\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=11;class=forearm;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"120\" y=\"120\" width=\"34.49\" height=\"130\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"calves\" id=\"Tunu-VMid14RNrtfkO_W-13\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=10;class=calves;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"257.5300080377642\" y=\"799.9988169776213\" width=\"50.17\" height=\"205.99\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"front quads\" id=\"Tunu-VMid14RNrtfkO_W-14\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-4;class=front quads;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"459.9952600855425\" y=\"609.9956191239531\" width=\"75.35\" height=\"180\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"side\" id=\"Tunu-VMid14RNrtfkO_W-15\"> <mxCell style=\"shape=xor;whiteSpace=wrap;html=1;rotation=75;direction=west;class=side;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"269.42427155842927\" y=\"191.24485604278408\" width=\"44.26\" height=\"85.99\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"biceps\" id=\"Tunu-VMid14RNrtfkO_W-16\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=90;class=biceps;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"611\" y=\"196.24\" width=\"59.94\" height=\"100\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"forearm\" id=\"Tunu-VMid14RNrtfkO_W-17\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-195; class=forearm;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"709.9957454780304\" y=\"129.99626804936668\" width=\"34.49\" height=\"130\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"pec major\" id=\"Tunu-VMid14RNrtfkO_W-18\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-205;class=pec major;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"418.2466094821475\" y=\"260.7356783963344\" width=\"122.39\" height=\"98.77\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"pec minor\" id=\"Tunu-VMid14RNrtfkO_W-19\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=115;class=pec minor;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"243.57\" y=\"283.42\" width=\"50.9\" height=\"84.99\" as=\"geometry\" /> </mxCell> </object> <object label=\"\" class=\"pec minor\" id=\"Tunu-VMid14RNrtfkO_W-20\"> <mxCell style=\"ellipse;whiteSpace=wrap;html=1;rotation=-120;class=pec minor;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"542.6391841714233\" y=\"283.4196962127537\" width=\"50.9\" height=\"84.99\" as=\"geometry\" /> </mxCell> </object> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.1,
    cy: 192.13,
    rx: 61.19500000000001,
    ry: 49.385,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(15,252.1,192.13)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.97,
    cy: 127.24,
    rx: 29.970000000000002,
    ry: 50,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(90,89.97,127.24)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.93,
    y: 284,
    width: 41,
    height: 196.18,
    rx: 16.4,
    ry: 16.4,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.24,
    y: 284,
    width: 41,
    height: 196.18,
    rx: 16.4,
    ry: 16.4,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 248.35 303.62 Q 272.35 303.62 272.35 382.09 Q 272.35 460.56 248.35 460.56 Q 260.35 382.09 248.35 303.62 Z",
    fill: "#ffffff",
    stroke: "#000000",
    strokeMiterlimit: 10,
    transform: "rotate(-180,260.35,382.09)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 382.67 303.62 Q 406.67 303.62 406.67 382.09 Q 406.67 460.56 382.67 460.56 Q 394.67 382.09 382.67 303.62 Z",
    fill: "#ffffff",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-9"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 415 71 Q 459.26 71 459.26 114 Q 459.26 156.99 415 156.99 Q 437.13 114 415 71 Z",
    fill: "#ffffff",
    stroke: "#000000",
    strokeMiterlimit: 10,
    transform: "rotate(273,437.13,113.99)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.67,
    cy: 582,
    rx: 37.675,
    ry: 90,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(9,229.67,582)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.7,
    cy: 774.99,
    rx: 25.085,
    ry: 102.99499999999999,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(-8,366.7,774.99)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.24,
    cy: 67,
    rx: 17.245,
    ry: 65,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(11,29.24,67)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-13"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.62,
    cy: 784.99,
    rx: 25.085,
    ry: 102.99499999999999,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(10,174.62,784.99)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 389.67,
    cy: 582,
    rx: 37.675,
    ry: 90,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(-4,389.67,582)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-15"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 161.42 73.24 Q 205.68 73.24 205.68 116.24 Q 205.68 159.23 161.42 159.23 Q 183.55 116.24 161.42 73.24 Z",
    fill: "#ffffff",
    stroke: "#000000",
    strokeMiterlimit: 10,
    transform: "rotate(255,183.55,116.24)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-16"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 532.97,
    cy: 128.24,
    rx: 29.970000000000002,
    ry: 50,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(90,532.97,128.24)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-17"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.24,
    cy: 77,
    rx: 17.245,
    ry: 65,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(-195,619.24,77)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-18"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 371.44,
    cy: 192.12,
    rx: 61.19500000000001,
    ry: 49.385,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(-205,371.44,192.12)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-19"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.02,
    cy: 207.91,
    rx: 25.45,
    ry: 42.495,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(115,161.02,207.91)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Tunu-VMid14RNrtfkO_W-20"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.09,
    cy: 207.91,
    rx: 25.45,
    ry: 42.495,
    fill: "#ffffff",
    stroke: "#000000",
    transform: "rotate(-120,460.09,207.91)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusclesFrontLayer1Drawio);
export default __webpack_public_path__ + "static/media/muscles_front_layer_1.drawio.4cd4eb4c5ffd5997502fbdeca1f9947a.svg";
export { ForwardRef as ReactComponent };